export const STRIPE_NAMESPACE = "stripe";
